import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

export default function Cta({ secondaryTo = '/', secondaryLabel, secondaryState }) {
  const { isEN } = useLanguage();
  const resolvedSecondaryLabel = secondaryLabel ?? (isEN ? 'Back to Home' : 'العودة للرئيسية');
  return (
    <section className="cta-a section">
      <div className="cta-a__glow"></div>
      <div className="wrap">
        <span className="eyebrow" style={{ justifyContent: 'center', color: 'var(--champagne)' }} data-reveal>{isEN ? 'Partnership & Cooperation' : 'شراكة وتعاون'}</span>
        <h2 data-reveal data-delay="1">{isEN ? <>Let us build <b>sustainable value</b> together</> : <>لنبنِ <b>قيمةً مستدامة</b> معاً</>}</h2>
        <p data-reveal data-delay="2">{isEN ? 'We welcome strategic partnerships and cooperation opportunities across the Group’s sectors, in Egypt and abroad.' : 'نرحّب بالشراكات الاستراتيجية وفرص التعاون في قطاعات المجموعة داخل مصر وخارجها.'}</p>
        <div className="cta-a__btns" data-reveal data-delay="3">
          <Link className="btn btn-gold" to="/contact"><span>{isEN ? 'Contact Us' : 'تواصل معنا'}</span> <span className="arr">←</span></Link>
          <Link className="btn btn-outline" to={secondaryTo} state={secondaryState}>{resolvedSecondaryLabel}</Link>
        </div>
      </div>
    </section>
  );
}
